module.exports = __webpack_public_path__ + "ded9e90132b17632f691d954349a6f7c.pdf";